import { render, staticRenderFns } from "./OrderCompleteById.vue?vue&type=template&id=01850471&"
import script from "./OrderCompleteById.vue?vue&type=script&lang=ts&"
export * from "./OrderCompleteById.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports